export const SEATS_VERSIONS_FEATURE_FLAG = 'SEATS_VERSIONS_FEATURE_FLAG';